/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
// TODO: get customizer for the component as per its parent toolbar/component using component-parent map  (HUD/LHP/Topbar)
// Currently only HUD components are customizable
import { allowedCustomizablePanels, customizableComponentParent } from "constants/enums";

export const getUIControlCustomizer = (stores, componentName, config) => {
  const customizerFnArray = [];
  let finalParentContainersArray = [];
  const parentContainerIDs =
    typeof config === "object" && config.hasOwnProperty("containerIDs") ? config.containerIDs : [];

  if (parentContainerIDs && parentContainerIDs.length > 0) {
    finalParentContainersArray = parentContainerIDs;
  } else if (customizableComponentParent[componentName]) {
    finalParentContainersArray = customizableComponentParent[componentName];
  }

  finalParentContainersArray.forEach(customizableComponent => {
    if (customizableComponent === allowedCustomizablePanels.HUD) {
      customizerFnArray.push(stores.hudStore.customizeHudComponent);
    } else if (customizableComponent === allowedCustomizablePanels.DOCUMENT) {
      customizerFnArray.push(stores.documentStore.customizeDocComponent);
    } else if (customizableComponent === allowedCustomizablePanels.TOP_BAR) {
      customizerFnArray.push(stores.topbarStore.customizeTopBarComponent);
    } else if (customizableComponent === allowedCustomizablePanels.PAGED_VIEW_STATE) {
      customizerFnArray.push(stores.pagedViewState.customizePagedViewStateComponent);
    } else if (customizableComponent === allowedCustomizablePanels.QUICK_TOOLS) {
      customizerFnArray.push(stores.quickToolsStore.setComponentProperties);
    } else if (customizableComponent === allowedCustomizablePanels.CONTEXT_MENU) {
      customizerFnArray.push(stores.contextMenuStore.setComponentProperties);
    } else if (customizableComponent === allowedCustomizablePanels.SKINNY_RAIL) {
      customizerFnArray.push(stores.skinnyRailStore.setComponentProperties);
    }
  });

  return customizerFnArray;
};

export const getUIConfigApis = stores => {
  function customizeUIControl(componentName, config) {
    return new Promise((resolve, reject) => {
      try {
        const customizerArray = getUIControlCustomizer(stores, componentName, config);
        if (Array.isArray(customizerArray)) {
          customizerArray.forEach(customizerFn => customizerFn(componentName, config));
        }
        resolve(true);
      } catch (e) {
        reject(e);
      }
    });
  }
  return {
    customizeUIControl
  };
};
